import * as React from 'react';
import { IChoiceGroupOption, MessageBar, MessageBarType } from "office-ui-fabric-react";
import { ProgressCalculationType } from "../../../entities/common";
import { SettingDropdown, SettingDropdownOption } from './SettingDropdown';


export const progressCalculationTypeOptions: IChoiceGroupOption[] = [
    {
        text: 'Effort',
        value: ProgressCalculationType.Effort,
        key: ProgressCalculationType.Effort.toString(),
    },
    {
        text: 'Story Points',
        value: ProgressCalculationType.StoryPoints,
        key: ProgressCalculationType.StoryPoints.toString(),
    },
    {
        text: 'Average Progress',
        value: ProgressCalculationType.AverageProgress,
        key: ProgressCalculationType.AverageProgress.toString(),
    }
];

export const progressCalculationTypeDescriptionsMap = {
    [ProgressCalculationType.Effort]: <>Progress is calculated by the formula: (Completed Work / Effort) * 100%</>,
    [ProgressCalculationType.StoryPoints]: <>Progress is calculated by the formula: (Completed Story Points / Story Points) * 100%</>,
    [ProgressCalculationType.AverageProgress]: <>Progress is calculated as average of Progress, % from “leaf” tasks</>
}

const dropdownOptions: SettingDropdownOption[] = progressCalculationTypeOptions.map(_ => ({
    key: _.value as ProgressCalculationType,
    text: _.text,
    description: progressCalculationTypeDescriptionsMap[_.value as ProgressCalculationType]
}));

export const ProjectCalculationSection = (props: {
    value?: ProgressCalculationType,
    onChange: (value: ProgressCalculationType) => void,
    readonly?: boolean,
    lockedByFixedUnits?: boolean
}) => {
    const value = props.value ?? ProgressCalculationType.Effort;
    return <div className="project-calculation">
        <SettingDropdown
            label="Calculate Progress by"
            required
            info={<>Select Progress Calculation rule for PPM Express tasks, task groups and rolled up project progress.</>}
            selectedKey={value}
            options={dropdownOptions}
            disabled={props.readonly}
            onChange={key => props.onChange(key as ProgressCalculationType)} />
        {props.lockedByFixedUnits
            ? <MessageBar messageBarType={MessageBarType.warning} isMultiline styles={{ root: { marginTop: 8 } }}>
                Progress Calculation rule cannot be changed while the project contains Fixed Units tasks. Remove them first to unlock this setting.
            </MessageBar>
            : <MessageBar messageBarType={MessageBarType.warning} isMultiline styles={{ root: { marginTop: 8 } }}>
                Rolled up Progress for task groups and project will be automatically re-calculated.
                For Manual Tasks to re-calculate Progress use Calculate Progress feature.
                For Auto Tasks Progress will be re-calculated automatically.
            </MessageBar>}
    </div>;
}
